import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const EvaluationTypeModal = ({ isOpen, onClose, onSelectEvaluationType }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
    } else {
      document.body.style.overflow = 'unset';
      document.body.style.position = '';
      document.body.style.width = '';
      const scrollY = document.body.style.top;
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    return () => {
      document.body.style.overflow = 'unset';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handleSelectType = (type) => {
    onSelectEvaluationType(type);
  };

  const BETA = true;

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
      {             }
      <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

      {           }
      <div className="relative bg-[#0f1e2e] rounded-2xl p-6 md:p-8 w-full max-w-md" dir="rtl">
        {            }
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-white mb-2">اختر نوع التقييم</h2>
          <p className="text-gray-400">اختر ما تريد تقييمه</p>
        </div>

        {             }
        <div className="space-y-4">
          {                                  }
          <button
            onClick={() => handleSelectType('courses')}
            className="relative w-full p-4 bg-[#1a2a3a] border border-[#28e3da40] rounded-xl text-white hover:bg-[#28e3da20] hover:border-[#28e3da] transition-all duration-200 text-lg font-medium overflow-hidden"
          >
            {                              }
            {BETA && (
              <div className="pointer-events-none absolute top-0 left-0 w-28 h-28">
                <div className="absolute top-4 left-[-34px] rotate-[-45deg] w-44 bg-amber-400/20 border border-amber-400/30 text-amber-200 text-xs font-bold py-1 text-center tracking-widest shadow-lg">
                  تحت التطوير
                </div>
              </div>
            )}

            {                           }
            <span className="block w-full text-center">
              تقييم المقررات
            </span>
          </button>

          {               }
          <button
            onClick={() => handleSelectType('lecturers')}
            className="w-full p-4 bg-[#1a2a3a] border border-[#28e3da40] rounded-xl text-white hover:bg-[#28e3da20] hover:border-[#28e3da] transition-all duration-200 text-lg font-medium text-center"
          >
            تقييم المحاضرين
          </button>
        </div>

        {                  }
        <button
          onClick={onClose}
          className="absolute top-4 left-4 w-10 h-10 bg-[#1a2a3a] rounded-lg flex items-center justify-center text-white hover:bg-[#2a3a4a] transition-colors"
          aria-label="إغلاق"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>,
    document.body
  );
};

export default EvaluationTypeModal;
